import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { social } from "@/config/brand";
import { api, formatApiError } from "@/lib/api";
import { SOCIAL_ICONS as ICONS } from "@/components/common/SocialIcons";

export function FooterNewsletter() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(data.message || "Subscribed");
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Subscription failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={subscribe} className="mt-6 max-w-sm">
      <label className="text-luxe text-[10px] text-ivory/70">Join our world</label>
      <div className="mt-2 flex border-b border-ivory/30 focus-within:border-gold">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email address"
          data-testid="footer-newsletter-input"
          className="flex-1 bg-transparent py-2 text-sm text-ivory placeholder:text-ivory/40 focus:outline-none"
        />
        <button type="submit" disabled={busy} aria-label="Subscribe" data-testid="footer-newsletter-submit" className="px-2 text-ivory transition-colors hover:text-gold disabled:opacity-50">
          <ArrowRight size={18} />
        </button>
      </div>
    </form>
  );
}

export function FooterSocial() {
  return (
    <div className="mt-6 flex gap-3">
      {social.map((s) => {
        const Icon = ICONS[s.icon] || Instagram;
        return (
          <a
            key={s.label}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={s.label}
            className="grid h-9 w-9 place-items-center rounded-full border border-ivory/20 text-ivory/80 transition-colors hover:border-gold hover:text-gold"
          >
            <Icon size={16} />
          </a>
        );
      })}
    </div>
  );
}

export function FooterLinks({ columns }) {
  return (
    <div className="grid grid-cols-2 gap-8 sm:grid-cols-4 lg:col-span-8">
      {columns.map((col) => (
        <div key={col.title}>
          <h3 className="text-luxe text-[11px] font-semibold text-ivory/90">{col.title}</h3>
          <ul className="mt-4 space-y-2.5">
            {col.links.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-ivory/60 transition-colors hover:text-gold">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
